import { useEffect, useState } from "react";
import { axiosPost } from "../../../utils/AxiosApi";
import { URL } from "../../../utils/Constants";
import swal from "sweetalert";
import { useARRCode } from "../context/ARRLevelContext";

export const useSubjectArea = (pageSize) => {
  const { arrLevel } = useARRCode();
  const [subjectArea, setSubjectArea] = useState([]);
  const [totalRecordsCount, setTotalRecordsCount] = useState(0);
  const [loading, setLoading] = useState({
    read: false,
    create: false,
    update: false,
    delete: false,
  });

  //fetch subject area
  const getSubjectArea = (page = 1) => {
    setLoading((prev) => ({ ...prev, read: true }));
    axiosPost(
      URL.subjectAreaList,
      {
        assessmentModuleCode: arrLevel,
        limit: pageSize,
        offset: page - 1,
      },
      (response) => {
        if (response.status === 200) {
          setSubjectArea(response?.data?.data ?? []);
          setTotalRecordsCount(response?.data?.totalRecordsCount);
        }
        setLoading((prev) => ({ ...prev, read: false }));
      },
      (err) => {
        swal("Oops, Failed to get subject area");
        setLoading((prev) => ({ ...prev, read: false }));
        return;
      },
    );
  };

  //create subject area
  const createSubjectArea = (data) => {
    setLoading((prev) => ({ ...prev, create: true }));

    if (!data || !data.name) {
      setLoading((prev) => ({ ...prev, create: false }));
      return Promise.reject("Name is required");
    }

    return new Promise((resolve, reject) => {
      axiosPost(
        URL.insertSubjectAreaList,
        {
          assessmentModuleCode: arrLevel,
          description: data?.description || "",
          name: data.name,
        },
        (response) => {
          setLoading((prev) => ({ ...prev, create: false }));

          if (response.status === 200) {
            swal("Success", response?.message || "Created successfully");
            resolve(response);
          } else {
            reject(response);
          }
        },
        (error) => {
          setLoading((prev) => ({ ...prev, create: false }));

          swal(
            "Oops",
            error?.response?.data?.message || "Failed to create subject area",
          );

          reject(error);
        },
      );
    });
  };

  //update subject area
  const updateSubjectArea = (data) => {
    setLoading((prev) => ({ ...prev, update: true }));

    if (!data || !data.name || !data.id) {
      setLoading((prev) => ({ ...prev, update: true }));
      return null;
    }

    return new Promise((resolve, reject) => {
      axiosPost(
        URL.updateSubjectAreaList,
        {
          assessmentModuleCode: arrLevel,
          id: data.id,
          description: data?.description || "",
          name: data.name,
        },
        (response) => {
          if (response.status === 200) {
            swal(
              "Success",
              response?.message || "Subject area updated successfully",
            );
            resolve(response);
          } else {
            reject(response);
          }
          setLoading((prev) => ({ ...prev, update: false }));
        },
        (error) => {
          setLoading((prev) => ({ ...prev, update: false }));
          swal(
            "Oops",
            error?.response?.data?.message || "Failed to update subject area",
          );
          reject(error);
        },
      );
    });
  };

  //delete subject area
  const deleteSubjectArea = (id) => {
    setLoading((prev) => ({ ...prev, delete: true }));
    return new Promise((resolve, reject) => {
      axiosPost(
        URL.deleteSubjectAreaList,
        {
          id: id,
        },
        (response) => {
          if (response.status === 200) {
            swal(
              "Success",
              response?.message || "Subject Area deleted Successfully",
            );
            resolve(response);
          } else {
            reject(response);
          }
          setLoading((prev) => ({ ...prev, delete: false }));
        },
        (error) => {
          swal(
            "Oops",
            error?.response?.data?.message || "Failed to delete subject area",
          );
          setLoading((prev) => ({ ...prev, delete: false }));
          reject(error);
        },
      );
    });
  };

  useEffect(() => {
    getSubjectArea();
  }, [arrLevel]);

  return {
    subjectArea,
    totalRecordsCount,
    loading,
    createSubjectArea,
    updateSubjectArea,
    deleteSubjectArea,
    refetch: getSubjectArea,
  };
};
